import { useQuery } from '@tanstack/react-query';
import { getPublicPricing } from '../Api/publicPricingApi';

const PUBLIC_PRICING_KEY = 'public-pricing';

export const usePublicPricing = (options = {}) =>
	useQuery({
		queryKey: [PUBLIC_PRICING_KEY],
		queryFn: async () => {
			const response = await getPublicPricing();
			return response?.data?.data || {
				plans: [],
				featureRows: [],
				lifetimePlans: [],
				lifetimeFeatureRows: [],
			};
		},
		staleTime: 5 * 60 * 1000,
		...options,
	});

export const mapPublicPlanToTier = (plan) => ({
	name: plan.name,
	monthly: plan.pricing?.monthly?.amount ?? null,
	yearly: plan.pricing?.yearly?.annualTotal ?? null,
	yearlyFormatted: plan.pricing?.yearly?.formattedAnnual ?? null,
	tagline: plan.description,
	highlight: plan.isPopular,
	features: plan.highlights || [],
	isCustom: plan.isCustom,
	annualSavings: plan.pricing?.annualSavings,
	pricingMode: 'saas',
});

export const mapLifetimePlanToTier = (plan) => ({
	name: plan.name,
	lifetimePrice: plan.pricing?.lifetime?.amount ?? null,
	lifetimePriceFormatted: plan.pricing?.lifetime?.formatted ?? null,
	appsumoTier: plan.appsumoTier,
	appsumoCodesRequired: plan.appsumoCodesRequired || 1,
	tagline: plan.description,
	highlight: plan.isPopular,
	features: plan.highlights || [],
	pricingMode: 'lifetime',
});
